import $ from 'jquery';
import 'jquery-ui/ui/core.js';
import 'jquery-ui/ui/disable-selection';
import 'jquery-ui/ui/widgets/slider';
import "jQuery-ui-Slider-Pips";
import "jquery-ui-touch-punch";

function initialize(context, force) {

    context = context || document;
    if (!$('div[data-slider]', context).length) {
        return;
    }

    $('div[data-slider]', context).each(function () {
        var $this = $(this);
        if (!force && $this.parents('.modal').length || $this.parents('.modal').length && $this.parents('.modal').parents('.ajax-response').length) {
            return;
        }

        var $input = null;
        try {
            $input = $($this.attr('data-slider'));
        } catch (e) {}
        if (!$input.length) {
            $input = $('[name="' + $this.attr('data-slider') + '"]');
        }

        var defaultValue = $this.attr('data-slider-value'),
            sliderChange = function (e, ui) {
                if ($input.length) {
                    if (!$this.attr('data-slider-no-linking')) {
                        // Automatically update other sliders with the same data-slider attribute
                        var $others = $('.ui-slider[data-slider="' + $this.attr('data-slider') + '"]').not($this);
                        if ($others.length) {
                            $others.slider('value', ui.value);
                        }
                    }

                    // Update the value of the input field
                    $input.val(ui.value).trigger('slider-change');
                }
            };

        var options = {
            value: $input.length ? $input.val() : defaultValue,
            range: 'min',
            min: $this.attr('data-slider-min') ? parseInt($this.attr('data-slider-min')) : 1,
            max: $this.attr('data-slider-max') ? parseInt($this.attr('data-slider-max')) : 10,
            step: $this.attr('data-slider-step') ? parseInt($this.attr('data-slider-step')) : 1,
            slide: sliderChange,
            change: sliderChange
        };

        var orientation = ($this.attr('data-slider-orientation'));
        if (orientation) {
            options.orientation = orientation;
        }

        $this.slider(options);
        var disabled = $this.attr('data-slider-disabled') || $input.attr('disabled');

        if (disabled) {
            $this.slider('disable');
        }

        var ticks = ($this.attr('data-slider-ticks') + '').toLowerCase();
        if (ticks !== '0' && ticks !== 'false') {
            var settings = {
                rest: 'label'
            };

            var labels = ($this.attr('data-slider-labels'));
            if (labels) {
                settings.labels = JSON.parse(labels);
                settings.labels.forEach(function (value, index) {
                    settings.labels[index] = value!==false ? '' + value : value;
                });
            }

            var step = ($this.attr('data-slider-pip-step'));
            if (step) {
                settings.step = step;
            }

            $this.slider('pips', settings);
        }

        if ($input.length) {
            if (($input.val() === '' || $input.val() === '0')) {
                $this.one('mousedown', function () {
                    if (!disabled) {
                        $this.find('.ui-slider-handle').show();
                    }
                }).find('.ui-slider-handle').hide();
            }
        }
        else if (!defaultValue || defaultValue == 0) {
            $this.find('.ui-slider-handle').hide();
        }
    });
    
    
}


export default { initialize };